<app-header-list titulo="Lista de Pessoas"/>

<ion-content [fullscreen]="true">
  <p-table [lazy]="true" (onLazyLoad)="load($event)" #dt1 styleClass="p-datatable-striped" sortMode="multiple"
           [showCurrentPageReport]="true" responsiveLayout="scroll"
           currentPageReportTemplate="{first}-{last}/{totalRecords}"
           [pageLinks]="0" [totalRecords]="total"
           [rows]="100" [paginator]="true"  dataKey="id" [value]="entidades">
      <ng-template pTemplate="header">
        <tr style="vertical-align: top">
          <th pSortableColumn="nome"> Nome<br/>
            <div style="white-space: nowrap;">
              <p-sortIcon field="nome"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="nome"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="email"> E-mail<br/>
            <div>
              <p-sortIcon field="email"></p-sortIcon>
              <p-columnFilter display="menu" type="text" field="email"></p-columnFilter>
            </div>
          </th>
          <th pSortableColumn="funcoes"> Funções<br/>
            <div>
                                  <p-sortIcon field="funcoes"></p-sortIcon>
              <p-columnFilter matchMode="containsMember" display="menu" [showMatchModes]="false"
                              [showOperator]="false"
                              [showAddButton]="false" field="funcoes">

                <ng-template pTemplate="filter" let-funcoesSelecionadas let-filter="filterCallback">
                  <p-multiSelect [ngModel]="funcoesSelecionadas"
                                 [options]="funcoes" (onChange)="filter($event.value)"
                                 [filter]="false" placeholder="Qualquer">
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
              <!--                    <p-columnFilter display="menu" type="text" field="funcoes"></p-columnFilter>-->
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr style="cursor: pointer">
          <td><a routerLink="edit/{{item.id}}" >{{item.nome}}</a></td>
          <td><a routerLink="edit/{{item.id}}" >{{item.email}}</a></td>
          <td><a routerLink="edit/{{item.id}}" >{{item.funcoes}}</a></td>
        </tr>
      </ng-template>
    <ng-template pTemplate="loadingbody" let-columns="columns">
      <tr style="height:46px">
        <td><p-skeleton [ngStyle]="{'width': '33%'}"></p-skeleton></td>
        <td><p-skeleton [ngStyle]="{'width': '33%'}"></p-skeleton></td>
        <td><p-skeleton [ngStyle]="{'width': '33%'}"></p-skeleton></td>
      </tr>
    </ng-template>
    </p-table>
    <ion-fab slot="fixed"  vertical="bottom" horizontal="end">
      <ion-fab-button routerLink="new" color="success">
        <ion-icon  name="add"></ion-icon>
      </ion-fab-button>
    </ion-fab>
</ion-content>

<app-rodape [exibirBotoes]="false"/>
